import { Component, Input } from '@angular/core';

@Component({
  selector: 'bh-common-progress-bar',
  templateUrl: './progress-bar.component.html',
})
export class ProgressBarComponent {
  @Input() loadingText: string = "LOADING...";
  constructor() { }

}
